import { useQuery } from '@tanstack/react-query';

import {
  partnersIntegrationApi,
  partnersIntegrationApiKeys,
} from '@/api/routes/partners/partners.integration.api';

/**
 * The sports media integration of the account. `enabled: false` until the Bodyprint team creates
 * a key; the menu and the page follow it. Pass `active = false` before the account exists.
 */
export const usePartnersReadIntegration = (active = true) => {
  return useQuery({
    queryKey: partnersIntegrationApiKeys.all,
    queryFn: () => partnersIntegrationApi.read().then((res) => res.data),
    enabled: active,
  });
};
